<template>
  <v-col sm="12" class="overrideCol">
        <div
        >
          <l-map
            ref="map"
            :zoom="zoom"
            :max-zoom="maxZoom"
            :center="center"
            :options="mapOptions"
            :style="style"
            class="ml-2"
          >

            <l-tile-layer
              v-for="tile in tileProviders"
              :key="tile.name"
              :visible="tile.visible"
              :url="tile.url"
              :name="tile.name"
              :attribution="tile.attribution"
              layer-type="base"
            />
          </l-map>
          <RetroactivePoiResult v-if="retroactivePoiEnters.length" :poiEnters="retroactivePoiEnters"/>
        </div>
      </v-col>
</template>

<script>
import { MultiOptionsPolyline } from 'Leaflet.MultiOptionsPolyline'
import options from '../../../resource/maps/leafletOptions'
import EventBus from '../../../event-bus'
import BaseLeafletMapComponent from '../BaseLeafletMapComponent'
import { MapDataAdapterFactory } from '../../../utils/map/mapDataMutatorStrategy'
import { latLng } from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LControlLayers,
  LPolyline
} from 'vue2-leaflet'
import LDraw from 'leaflet-draw'
import { mapState } from 'vuex'

export default {
  name: 'LeafletRetroactivePoiEnteranceComponent',
  extends: BaseLeafletMapComponent,
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LDraw,
    LControlLayers,
    LControl,
    LPolyline,
    LPolygon: () => import('vue2-leaflet'),
    LCircle: () => import('vue2-leaflet'),
    RetroactivePoiResult: () =>
      import('@/components/map/retroactivePoi/RetroactivePoiResult')
  },
  data() {
    return {
      zoom: null,
      maxZoom: null,
      center: null,
      tileProviders: [],
      mapOptions: {
        zoomSnap: null
      },
      poiData: {},
      style: 'height: 100vh'
    }
  },
  created() {
    let { zoom, maxZoom, zoomSnap, center, tileProviders } = options
    this.zoom = zoom
    this.maxZoom = maxZoom
    this.center = latLng(center.lat, center.lng)
    this.tileProviders = tileProviders
    this.mapOptions.zoomSnap = zoomSnap
  },
  mounted() {
    this.handleRetroactivePoiControls()
  },
  computed: {
    ...mapState('retroactivePoi', ['retroactivePoiEnters']),
    ...mapState('map', ['pois'])
  },
  methods: {
    async handleRetroactivePoiControls() {
      const map = this.$refs.map.mapObject

      map.addControl(this.drawnPois)

      const drawControl = new window.L.Control.Draw({
        position: 'topleft',
        draw: {
          polygon: true,
          circle: true,
          polyline: false,
          rectangle: false,
          marker: false,
          circlemarker: false
        },
        edit: {
          featureGroup: this.drawnPois,
          remove: true
        }
      })

      window.L.EditToolbar.Delete.include({
        removeAllLayers: false
      })

      map.addControl(drawControl)

      map.on(window.L.Draw.Event.CREATED, e => {
        this.drawnPois.addLayer(e.layer)

        var layerData = {}

        layerData.eventType = e.layerType.toUpperCase()
        layerData[e.layerType] = e.layer

        var factory = new MapDataAdapterFactory()
        var strategy = factory.make('leaflet')
        var data = strategy.adapt(layerData)
        EventBus.$emit('TEMPORARY_POI', data)
      })

      map.on(window.L.Draw.Event.DELETED, e => {
        e.layers.eachLayer(layer => {
          if (layer instanceof L.Circle) {
            EventBus.$emit(
              'REMOVE_TEMPORARY_CIRCLE_POI_FROM_DROPDOWN',
              layer.getLatLng()
            )
          } else {
            EventBus.$emit(
              'REMOVE_TEMPORARY_POLYGON_POI_FROM_DROPDOWN',
              layer.getLatLngs()
            )
          }
        })
      })
    },
    zoomToSelectedPoi() {
      this.zoomToRoute(
        this.pois[0].coordinates.map(x => {
          return {
            latitude: x.latitude,
            longitude: x.longitude
          }
        })
      )
    },
    drawRetroactivePoiOnMap(data) {
      this.drawnPois.clearLayers()

      this.poiData.forEach(d => {
        d.visible = false
      })

      var foundPoi = this.poiData.find(x => x.name == data.name)

      foundPoi.visible = true

      this.handlePoisDrawing()

      var layers = this.drawnPois.getLayers()
      var bounds = L.latLngBounds([])

      layers.forEach(layer => {
        var layerBounds = layer.getBounds().pad(0.5)
        bounds.extend(layerBounds)
      })

      this.$refs.map.fitBounds(bounds)
    }
  },
  watch: {
    pois: {
      handler() {
        this.zoomToSelectedPoi()
      }
    },
    retroactivePoiEnters: {
      handler(value) {
        if (value && value.length) {
          this.style = 'height: 60vh'
        } else {
          this.style = 'height: 100vh'
        }

        this.$refs.map.mapObject._sizeChanged = true
        var that = this
        setTimeout(function() {
          that.zoomToSelectedPoi()
        }, 200)
      }
    }
  }
}
</script>

<style src="leaflet/dist/leaflet.css">
</style>
<style src="leaflet-draw/dist/leaflet.draw.css">
</style>
<style src="../../../assets/icons.css">
</style>
<style>
.vue2leaflet-map {
  z-index: 1 !important;
}
</style>
